// search transform
var searchWrapper = document.querySelector('.search-wrapper'),
  searchInput = document.querySelector('.search-input');

  const nav = document.querySelector('.navbar .overlay-content');
  const searchRelative = document.querySelector('.search');

document.addEventListener('click', function (e) {
  if (~e.target.className.indexOf('search')) {
    searchWrapper.classList.add('focused');
    nav.classList.add('opened-search');
    searchRelative.classList.add('mobile-opened');
    searchInput.focus();
  } else {
    searchWrapper.classList.remove('focused');
    nav.classList.remove('opened-search');
    searchRelative.classList.remove('mobile-opened');
  }
});

//add submit to search icon
$('span.icon-search').on('click', function () {
  if ($(this).parents('.focused').length) {
    $('form.search-wrapper').submit();
  }
});

$(window).on('scroll', function () {
  if ($(window).scrollTop() > 150) {
    $('header.navbar').addClass('smaller');
  } else {
    $('header.navbar').removeClass('smaller');
  }
});

$('.navbar-toggler').on('click', function () {
  $('body').addClass('no-scroll');
  $(this).siblings('.overlay').addClass('open');
});

$('.navbar-toggler-close').on('click', function () {
  $('body').removeClass('no-scroll');
  $(this).closest('.overlay').removeClass('open');
});
